import type { ReactElement } from "react";

import { Flex } from "@similarweb/ui-components/foundations";

const CELL_END_PADDING = "8px";

type EcommerceCellAlignProps = {
    children: React.ReactNode;
};

const EcommerceCellAlign = ({ children }: EcommerceCellAlignProps): ReactElement => (
    <Flex
        width="100%"
        justifyContent="flex-end"
        alignItems="center"
        padding={`0 ${CELL_END_PADDING} 0 0`}
    >
        {children}
    </Flex>
);

export default EcommerceCellAlign;
